<div class="suggestion-card">
    <h4 class="suggestion-card__title">{{ suggestion.suggestionTitle }}</h4>
    <p class="suggestion-card__skill">
        <b>Habilidad:</b> {{ suggestion.skill }}
    </p>
    <p class="suggestion-card__author">
        <b>Realizado por:</b> {{ suggestion.userName }}
    </p>
    <p class="suggestion-card__date">
        {{ suggestion.completedAt | date: 'longDate' }}
    </p>

    <div class="suggestion-card__preview" (click)="downloadEvidence()">
        <ng-container *ngIf="isImage(suggestion.evidenceUrl); else fallback">
            <img [src]="suggestion.evidenceUrl" alt="Evidencia" class="suggestion-card__image" />
        </ng-container>

        <ng-template #fallback>
            <div class="suggestion-card__fallback" (click)="downloadEvidence()">
                <img src="assets/pre-test/test-bw.png" alt="Archivo adjunto" class="suggestion-card__fallback-image" />
                <p class="suggestion-card__fallback-text">📎 Descargar archivo adjunto</p>
            </div>
        </ng-template>
    </div>

</div>